import React, { useState } from "react";
import { Background, Parallax } from 'react-parallax';
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb";
import ShoppingModal from "../../../shared/components/molecules/shopping-modal/shopping-modal";
import FilterProducts from "../../molecules/filter-products/filter-products";
import ListProducts from "../../molecules/list-products/list-products";
import './filter-content.scss';

// import SEO from "../shared/components/atoms/seo/seo"

const FilterContent = ({ params, products, guideline, filters }) => {

    const [intialProducts] = useState(
        () => {
            if (filters[0].slug === params.slug) {
                return products.filter(product => product.isVisible === true);
            } else {
                return products.filter(product => (product.categoria?.find(element => element.idCategoria === params.slug)) && (product.isVisible === true));
            }

        }
    )

    const [productFilter, setProductFilter] = useState(products.filter(product => product.isVisible === true))
    const [activeShoppingModal, setActiveShoppingModal] = useState(false);

    return (
        <div className="f-o-filterContent">
            {activeShoppingModal && <ShoppingModal setActiveShoppingModal={setActiveShoppingModal} />}
            <Parallax
                className="f-o-filterContent__parallax"
                strength={-1200}>
                <Background className="custom-bg">
                </Background>
            </Parallax>
            <Breadcrumb />
            <div className="f-o-filterContent__parallax"></div>
            <div className="f-o-filterContent__content">
                <h1>{params.metaTitulo}</h1>
                <div className="f-o-filterContent__content-wrap">
                    <FilterProducts active={params.slug} filters={filters} products={intialProducts} setProducts={setProductFilter} />
                    <ListProducts products={productFilter} guideline={guideline} setActiveShoppingModal={setActiveShoppingModal} />
                </div>
            </div>

        </div>
    )
}

export default FilterContent